import { render, staticRenderFns } from "./Label_Small.vue?vue&type=template&id=f22a778e&"
import script from "./Label_Small.vue?vue&type=script&lang=js&"
export * from "./Label_Small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports